<template>
    <div class="template">
        <NavbarDesktop class="template__Desktop" />
        <NavbarMobile class="template__Mobile" />
    </div>
</template>

<script>
import NavbarDesktop from '@/components/navbar/NavbarDesktop.vue'
import NavbarMobile from '@/components/navbar/NavbarMobile.vue'
export default {
    name: 'NavbarComponents',
    components: {
        NavbarDesktop,
        NavbarMobile
    }
}
</script>

<style lang=scss>
.template__Desktop{
    display: none;
}
.template__Mobile {
    display: block;
}
@media screen and (min-width: 1366px) {
    .template__Desktop {
        display: block;
    }
    .template__Mobile {
        display: none;
    }
}
</style>
